import { render, staticRenderFns } from "./SectionGroup.vue?vue&type=template&id=340d8b78&scoped=true"
import script from "./SectionGroup.vue?vue&type=script&lang=js"
export * from "./SectionGroup.vue?vue&type=script&lang=js"
import style0 from "./SectionGroup.vue?vue&type=style&index=0&id=340d8b78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340d8b78",
  null
  
)

export default component.exports